'use client'

import { useState } from 'react'
import Link from 'next/link'
import styles from '../../page.module.scss'
import { Col, Row } from 'react-bootstrap'
import BlogDefault from '@/assets/blogs/blog-2.png'
import { getFileUrl } from '@/utils'

const RelatedContent = ({ data }) => {
	const [contentList, setContentList] = useState(data?.content_summary)
	return (
		<div>
			<div className='heading2 mb-5'>Related Blogs</div>
			<div className={styles.glossaryRelatedContent}>
				{contentList?.map((item, index) => {
					const _imageUrl = item?.image_path?.includes('http') ? item?.image_path : getFileUrl + item?.image_path
					return (
						<Link href={`/blogs/${item.slug}`}>
							<Row key={`related-content-${index}`} className={styles.relatedContentCard}>
								<Col lg={5} md={3} sm={3} xs={5} className={styles.relatedContentImage}>
									<img
										src={_imageUrl}
										className=' rounded-2'
										alt={data?.title}
										onError={(e) => {
											e.target.src = `${BlogDefault.src}`
										}}
										//   onerror={""}
									/>
								</Col>
								<Col>
									<div className='d-flex row h-100'>
										<p className='paragraph'>{item?.title?.length > 40 ? item.title.substr(0, 40) + '...' : item.title}</p>
										<div className='d-flex align-items-center gap-2'>
											<svg xmlns='http://www.w3.org/2000/svg' width='6' height='7' viewBox='0 0 6 7' fill='none'>
												<circle cx='3' cy='3.12207' r='3' fill='#B2B1B4'></circle>
											</svg>
											<span className={styles.cardText}>{item?.source}</span>
										</div>
									</div>
								</Col>
							</Row>
						</Link>
					)
				})}
			</div>
		</div>
	)
}

export default RelatedContent
